<template>
  <div>
    <label class="bm-label">{{ labelVal }}</label>
    <bm-tooltip v-if="tooltipVal" bottom class="bm-tooltip">
      <template #activator="{ on }">
        <v-icon small v-on="on">info</v-icon>
      </template>
      <span>{{ tooltipVal }}</span>
    </bm-tooltip>
    <bm-read-only-field v-show="readOnly">
      {{ radioLabel }}
    </bm-read-only-field>
    <v-radio-group
      v-show="!readOnly"
      ref="radiogroup"
      class="bm-radio-group"
      :value="value"
      v-bind="$attrs"
      @change="$emit('input', $event)"
    >
      <slot></slot>
    </v-radio-group>
  </div>
</template>

<script lang="ts">
import BmTooltip from "@/components/controls/input/BmTooltip.vue";
import BmReadOnlyField from "@/components/controls/input/BmReadOnlyField.vue";
import BmLabelled from "@/components/controls/input/mixins/BmLabelled";
import { defineComponent } from "vue";

export default defineComponent({
  name: "BmRadioGroup",
  components: { BmTooltip, BmReadOnlyField },
  mixins: [BmLabelled],
  props: {
    value: {},
    readOnly: {
      type: Boolean,
    },
  },
  data() {
    return {
      isMounted: false,
    };
  },
  computed: {
    /**
     * Gets the label of the currently selected child radio.
     */
    radioLabel(): any {
      if (this.isMounted) {
        for (let radio of (this.$refs.radiogroup as any).items) {
          if (radio.value === this.value) {
            return radio.label;
          }
        }
      }
      return "";
    },
  },
  mounted() {
    this.isMounted = true;
  },
});
</script>

<style lang="sass">
@import "src/sass/typography"

.bm-label
  @include bm-field-label

.bm-tooltip
  padding-left: 5px
</style>
